<div class="relative">
  <div
    class="input w-full rounded-lg min-h-0 h-auto flex flex-wrap items-center gap-2 px-3 py-2"
    [class.input-error]="errorMessage()">
    @for (tag of tags(); track tag; let index = $index) {
    <div data-testid="tag-item"
      class="bg-primary text-white rounded-lg flex flex-row items-center py-[7px] flex-shrink-0 max-w-full">
      <p
        class="text-xs px-5 break-all overflow-wrap-anywhere max-w-[200px] truncate">
        {{ tag }}
      </p>
      <button
        id="remove-tag-button"
        data-testid="remove-tag-button"
        (click)="removeTag(index)"
        class="cursor-pointer pr-[5px] flex-shrink-0"
        type="button">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.7885 2.78886C5.6815 -0.10414 10.3593 -0.144788 13.3021 2.6975C16.1444 5.64035 16.1038 10.3181 13.2108 13.2111C10.3178 16.1041 5.63998 16.1448 2.69714 13.3025C-0.145155 10.3597 -0.104506 5.68187 2.7885 2.78886ZM11.4165 10.6625C11.4165 10.4625 11.3366 10.2708 11.1946 10.13L9.05714 8L11.1946 5.87C11.3849 5.67976 11.4592 5.40247 11.3895 5.14259C11.3199 4.88272 11.1169 4.67973 10.857 4.61009C10.5972 4.54046 10.3199 4.61476 10.1296 4.805L7.99964 6.9425L5.86964 4.805C5.67939 4.61476 5.40211 4.54046 5.14223 4.61009C4.88235 4.67973 4.67936 4.88272 4.60973 5.14259C4.54009 5.40247 4.61439 5.67976 4.80464 5.87L6.94214 8L4.80464 10.13C4.66265 10.2708 4.58279 10.4625 4.58279 10.6625C4.58279 10.8625 4.66265 11.0542 4.80464 11.195C4.94618 11.3354 5.13778 11.4137 5.33714 11.4125C5.53649 11.4137 5.7281 11.3354 5.86964 11.195L7.99964 9.0575L10.1296 11.195C10.2712 11.3354 10.4628 11.4137 10.6621 11.4125C10.8615 11.4137 11.0531 11.3354 11.1946 11.195C11.3366 11.0542 11.4165 10.8625 11.4165 10.6625Z"
            fill="white" />
        </svg>
      </button>
    </div>
    }

    <input
      data-testid="email-tag-input"
      [id]="id()"
      class="outline-none border-none flex-1 min-w-[120px] bg-transparent py-1 placeholder-gray-300 text-base"
      type="email"
      [value]="inputValue()"
      (input)="onInputChange($event)"
      (blur)="onBlur()"
      (focus)="onFocus()"
      (keydown.enter)="$event.preventDefault()"
      (keydown.enter)="addTag()"
      (keydown.tab)="$event.preventDefault()"
      (keydown.backspace)="removeTagByBackspace()"
      placeholder="Add email and press Enter" />
  </div>

  @if (errorMessage()) {
  <div class="absolute top-full left-0 text-error text-sm mt-1 z-1 bg-white">
    {{ errorMessage() }}
  </div>
  }
</div>
